export const playgroundRules = [
  "All children must wear grip socks for safety, while adults are required to wear standard socks.",
  "Children must always be supervised by a parent or guardian.",
  "Shoes are not allowed in the playground.",
  "Outside food and drinks are permitted.",
  "Guests are responsible for their personal belongings. Please make sure to empty pockets before entering the ball pit.",
  "Adults are not allowed on the trampolines.",
  "Aggressive behavior or the use of inappropriate language is prohibited.",
  "Food and drinks are not allowed in the play areas.",
  "Follow equipment use guidelines to avoid injuries. We are not liable for injuries caused by misuse.",
  "Smoking, vaping, or alcohol are not permitted.",
  "A $450 fee will apply for any damage to our play mats resulting from not following the rules.",
  "A $500 fee will be charged for any damage to items in the party area, play area, restrooms, or elsewhere due to improper handling.",
];
